module.exports = __webpack_public_path__ + "static/media/piggy_world_dark.a96df976.png";